import React from 'react';
export function CourseOfFire() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2566">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2567">
        <div className="mb-12" data-id="element-2568">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2569">
            PPC Course of Fire
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2570">
            {/* Target A */}
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
            borderColor: '#ede9e0'
          }} data-id="element-2571">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-100" data-id="element-2572">
                <div className="w-8 h-8 rounded bg-[#1e3d2f] text-white flex items-center justify-center font-bold text-lg font-heading" data-id="element-2573">
                  A
                </div>
                <h3 className="text-xl font-bold uppercase" style={{
                fontFamily: 'Oswald, sans-serif',
                color: '#1e3d2f'
              }} data-id="element-2574">
                  "A" Target
                </h3>
              </div>

              <ol className="space-y-6 list-decimal list-inside text-gray-800" data-id="element-2575">
                <li className="font-medium" data-id="element-2576">
                  <span className="ml-2" data-id="element-2577">
                    7 yds. 12 rounds in 20 seconds from a standing position
                  </span>
                </li>
                <li data-id="element-2578">
                  <span className="font-medium ml-2" data-id="element-2579">
                    50 ft, 18 rounds in 90 seconds, consisting of:
                  </span>
                  <ul className="mt-3 space-y-2 list-disc list-inside ml-6 text-gray-600 font-normal" data-id="element-2580">
                    <li data-id="element-2581">6 rounds from a kneeling position</li>
                    <li data-id="element-2582">
                      6 rounds standing, using the left hand from the left side
                      of the barricade
                    </li>
                    <li data-id="element-2583">
                      6 rounds standing, using the right hand from the right
                      side of the barricade
                    </li>
                  </ul>
                </li>
              </ol>
            </div>

            {/* Target B */}
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
            borderColor: '#ede9e0'
          }} data-id="element-2584">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-100" data-id="element-2585">
                <div className="w-8 h-8 rounded bg-[#1e3d2f] text-white flex items-center justify-center font-bold text-lg font-heading" data-id="element-2586">
                  B
                </div>
                <h3 className="text-xl font-bold uppercase" style={{
                fontFamily: 'Oswald, sans-serif',
                color: '#1e3d2f'
              }} data-id="element-2587">
                  "B" Target
                </h3>
              </div>

              <ol className="space-y-6 list-decimal list-inside text-gray-800" data-id="element-2588">
                <li className="font-medium" data-id="element-2589">
                  <span className="ml-2" data-id="element-2590">
                    50 ft. 6 rounds in 12 seconds from a standing position
                  </span>
                </li>
                <li data-id="element-2591">
                  <span className="font-medium ml-2" data-id="element-2592">
                    50 ft. 24 rounds in 2 minutes and 45 seconds, consisting of:
                  </span>
                  <ul className="mt-3 space-y-2 list-disc list-inside ml-6 text-gray-600 font-normal" data-id="element-2593">
                    <li data-id="element-2594">6 rounds from a sitting position</li>
                    <li data-id="element-2595">6 rounds from a prone position</li>
                    <li data-id="element-2596">
                      6 rounds standing, using the left hand from the left side
                      of the barricade
                    </li>
                    <li data-id="element-2597">
                      6 rounds standing, using the right hand from the right
                      side of the barricade
                    </li>
                  </ul>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>;
}